import { Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { LanguageContext } from '../../../../../../../libs/Context';

const WebinarDesc = (props) =>
{
	const { description } = props;
	const [ showMore, setShowMore ] = useState(false);
	const toggleShowMore = () => setShowMore(!showMore);
	const descriptionRef = useRef<HTMLDivElement>(null);
	const [ desc, setDesc ] = useState({ count: 0, height: 0 });
	const defaultChars = 400;
	const maxHeight = 4;
	const isLongText = desc.count > defaultChars || desc.height > maxHeight;

	const descripText =	showMore || !isLongText ? description : `${description?.slice(0, defaultChars)}...`;
	const descStyle = { overflow: 'hidden', lineHeight: '1.5em', maxHeight: `calc(1.5em * ${maxHeight})` };
	const { language } = useContext(LanguageContext);

	useEffect(() =>
	{
		if (descriptionRef.current)
		{
			// Get the text content from the div and update character count
			const textContent = descriptionRef.current.textContent || '';

			const contentElement:any = descriptionRef.current;
			const lineHeight = parseFloat(getComputedStyle(contentElement).lineHeight);
			const elementHeight = contentElement.clientHeight;
			const lines = Math.floor(elementHeight / lineHeight);

			setDesc({ count: textContent.length, height: lines });
		}
	}, [ description ]); // Run whenever data.description changes

	return (
		<Typography variant='subtitle1' color={'#585858'}>
			<div ref={descriptionRef}
				style={desc.height > maxHeight && !showMore ? descStyle : {}}
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{ __html: descripText }}
			/>
			{isLongText &&
			<Typography component={'span'} style={{ cursor: 'pointer', color: 'var(--primaryColor)' }} onClick={toggleShowMore}>
								&nbsp;{showMore ? language?.readless : language?.readMore}
			</Typography>}
		</Typography>
	);
};

export default WebinarDesc;